import React from 'react'
// IMAGES
import imageIconTelephone from '../../../images/iconTelephone.png'

const ModalCreateAccount = ({ handleChange, values, _signUp, keyUid, token }) => {
    return (
        <div className="modal fade" id="createAccountModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="createAccountModal">Créer un compte</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div>
                            <div className='mt-3'>
                                <input type="text" className='form-control border-0 rounded-pill shadow p-2' placeholder="Prénom" values={values.surname} name='surname' onChange={handleChange} />
                            </div>
                            <div className='mt-3'>
                                <input type="text" className='form-control border-0 rounded-pill shadow p-2' placeholder="Nom" values={values.name} name='name' onChange={handleChange} />
                            </div>
                            <div className='mt-3'>
                                <input type="email" className='form-control border-0 rounded-pill shadow p-2' placeholder="Email" values={values.email} name='email' onChange={handleChange} />
                            </div>
                            <div className='mt-3'>
                                <input type="password" className='form-control border-0 rounded-pill shadow p-2' placeholder="Mot de passe" values={values.password} name='password' onChange={handleChange} />
                            </div>

                            {/* INPUT PHONE */}
                            <div className='mt-3'>
                                <div className="input-group rounded-pill shadow">
                                    <span 
                                        className="bg-white border-0 rounded-pill" 
                                        style={{ marginLeft:'1rem', paddingTop:'0.2rem'}}
                                    >
                                        <img 
                                            src={imageIconTelephone} 
                                            alt='image du logo' 
                                            style={{ height:20, width:20, marginTop:'0.2rem' }} 
                                        />
                                    </span>
                                    <input type="text" className='form-control border-0' value={values.phone} name='phone' onChange={handleChange} placeholder='Téléphone' />
                                    <span 
                                        className="bg-white border-0 rounded-pill" 
                                        style={{ marginRight:'1rem', paddingTop:'0.2rem', height:20, width:20 }}
                                    >
                                    </span> 
                                </div>
                            </div>

                            <div className='text-center my-5 '>
                                <button 
                                    type='button'
                                    className='btn btn-outline my-3 shadow rounded-pill' 
                                    data-bs-toggle="modal" 
                                    data-bs-target="#createAccountModal"
                                    disabled={values.surname && values.name && values.email && values.password ? false : true}
                                    // onClick={() => console.log('Modal Create Account ,;, ',values.surname, values.name, values.email, values.password, keyUid)}
                                    onClick={() => _signUp(values.name, values.surname, values.email, values.password, keyUid, token, values.phone)}
                                >Créer mon compte</button>  
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalCreateAccount